/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';

/**
 * region for styles*/
import { inputSearchKeywordStyle } from './style/inputSearchKeywordStyle';

/**
 * region for icons*/
import SearchIcon from '@material-ui/icons/Search';

class InputSearchKeyword extends Component {

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.search}>
                <div className={classes.searchIcon}>
                    <SearchIcon />
                </div>
                <InputBase
                    placeholder="Search…"
                    value={this.props.searchKeyword}
                    onChange={this.props.handleChange}
                    onKeyPress={this.props.onKeyPressSearchFilter}
                    classes={{ root: classes.inputRoot, input: classes.inputInput, }}
                    inputProps={{ 'aria-label': 'search' }} />
            </div>
        );
    }
}
InputSearchKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(inputSearchKeywordStyle)(InputSearchKeyword);





